import { useEffect, useState } from 'react'

import type { ApiResponse } from '../types/api'
import { api } from '../utils/api-client'

interface PlatformInfo {
  download_link: string
  download_link_light?: string
  download_link_dark?: string
  version: string
}

interface DownloadLinks {
  android: PlatformInfo
  google_play_android: PlatformInfo
  ios: PlatformInfo
  adjust: PlatformInfo
}

const emptyPlatformInfo: PlatformInfo = {
  download_link: '',
  download_link_light: '',
  download_link_dark: '',
  version: '',
}

const useAppDownload = () => {
  const [downloadLinks, setDownloadLinks] = useState<DownloadLinks>({
    android: { ...emptyPlatformInfo },
    google_play_android: { ...emptyPlatformInfo },
    ios: { ...emptyPlatformInfo },
    adjust: { ...emptyPlatformInfo },
  })

  useEffect(() => {
    const checkForUpdate = async () => {
      const updateRes = await api.post<ApiResponse<Partial<DownloadLinks>>>(
        '/ajax_datav2.php',
        { type: 'get_app_version' },
      )
      const { status, info } = updateRes.data
      if (status === 1) {
        setDownloadLinks(prev => ({ ...prev, ...info }))
      }
    }
    checkForUpdate()
  }, [])

  return downloadLinks
}

export default useAppDownload
